import React, { useEffect, useState, useMemo, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Breadcrumb, Col, Row } from "antd";
import { useParams } from "react-router-dom";

import Layout from "../layout/Layout";
import ExecutiveContent from "../components/executive-details/ExecutiveContent";
import ExecutiveHeader from "../components/executive-details/ExecutiveHeader";
import RightPanel from "../components/executive-details/RightPanel";
import {
  getExecutiveDetails,
  getExecutiveCompanyDetails,
  getEmployeeList,
  getSimilarExecutiveList,
} from "../actionCreator/executiveDetailsActionCreator";
import "../assets/css/dynemic-page.css";
import Loader from "../components/loader";
import { AuthContext } from "../context/AuthContext";

const ExecutiveDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const executiveDetails = useSelector(
    (state) => state.executiveDetailsReducer.executiveDetails
  );
  const [loading, setLoading] = useState(true);
  const { isExecutiveView } = useContext(AuthContext);

  useEffect(() => {
    if (!isExecutiveView && isAuthenticated) {
      navigate("/dashboard-view");
    }
  }, [isExecutiveView, navigate, isAuthenticated]);

  useMemo(() => {
    dispatch(getExecutiveDetails(id));
    dispatch(getExecutiveCompanyDetails(id));
  }, [id]);

  useMemo(() => {
    if (Object.keys(executiveDetails).length) {
      dispatch(getEmployeeList(id, executiveDetails?.company?.id));
      let exlevel;
      if (executiveDetails?.exlevel) {
        exlevel = executiveDetails?.exlevel?.id;
      } else {
        exlevel = 0;
      }

      dispatch(
        getSimilarExecutiveList(
          {
            id: executiveDetails?.id,
            selectedCompany: [executiveDetails?.company],
            selectedExecutiveLevel: [{ id: exlevel }],
          },
          {
            start: 0,
            end: 10,
          }
        )
      );
    }
  }, [executiveDetails]);

  useEffect(() => {
    Object.keys(executiveDetails).length ? setLoading(false) : setLoading(true);
  }, [Object.keys(executiveDetails).length]);

  return (
    <Layout>
      {!loading ? (
        <div className="wrapper companysummary padd-90">
          <Breadcrumb
            items={[
              {
                title: (
                  <Link to={isAuthenticated ? "/dashboard-view" : "/"}>
                    Home
                  </Link>
                ),
              },
              {
                title: <Link to="/search-executive">Search Executive</Link>,
              },
              {
                title: "Executive Summary",
              },
            ]}
            className="text-uppercase"
          />
          <Row gutter={[20, 20]} className="justify-content-between">
            <Col xs={24} lg={16} xl={18}>
              <ExecutiveHeader />

              <ExecutiveContent />
            </Col>
            <Col xs={24} lg={8} xl={6} className="mt-4">
              <RightPanel />
            </Col>
          </Row>
        </div>
      ) : (
        <Loader />
      )}
    </Layout>
  );
};

export default ExecutiveDetails;
